module.exports = __webpack_public_path__ + "static/media/CTA.5ffc0d29.svg";